import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "className", "onClick", "disabled", "href", "route", "target", "title", "rel", "enabled", "routeParams", "aria-label"];
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles } from 'react-jss';
import cx from 'classnames';
import withMemo from '../../decorators/withMemo';
import styles from './styles';
var Link = null;
var LinkParamsTransformer = function LinkParamsTransformer(props) {
  return props;
};
var useStyles = createUseStyles(styles);
var A = function A(props) {
  var _ref;
  var classes = useStyles(props);
  var children = props.children,
    className = props.className,
    onClick = props.onClick,
    disabled = props.disabled,
    href = props.href,
    route = props.route,
    target = props.target,
    title = props.title,
    rel = props.rel,
    enabled = props.enabled,
    routeParams = props.routeParams,
    ariaLabel = props['aria-label'],
    otherProps = _objectWithoutProperties(props, _excluded);
  var renderDefault = useMemo(function () {
    return /*#__PURE__*/React.createElement("div", {
      className: className,
      onClick: !disabled ? onClick : undefined
    }, children);
  }, [className, disabled, onClick, children]);
  var params = LinkParamsTransformer(props);
  var renderAsLink = target && target !== '_self' || href && (href.match(/^(h|\/\/)/) || href.match(/^mailto:/)) || !Link || !params ? /*#__PURE__*/React.createElement("a", _extends({}, otherProps, {
    title: title,
    href: href,
    "aria-label": ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : title,
    target: target,
    className: cx(classes.link, className),
    onClick: onClick,
    rel: rel
  }), children) : /*#__PURE__*/React.createElement(Link, _extends({}, params, otherProps, {
    title: title !== null && title !== void 0 ? title : undefined,
    "aria-label": (_ref = ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : title) !== null && _ref !== void 0 ? _ref : undefined,
    className: cx(classes.link, className),
    onClick: onClick,
    target: target,
    rel: rel
  }), children);
  return /*#__PURE__*/React.createElement(React.Fragment, null, (href || route) && !disabled ? renderAsLink : renderDefault);
};
A.setLinkComponent = function (linkComponent) {
  Link = linkComponent;
};
A.setLinkParamsTransformer = function (linkParamsTransformer) {
  LinkParamsTransformer = linkParamsTransformer;
};
A.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  onClick: PropTypes.func,
  href: PropTypes.string,
  route: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  routeParams: PropTypes.object,
  target: PropTypes.string,
  title: PropTypes.string,
  'aria-label': PropTypes.string,
  disabled: PropTypes.bool,
  enabled: PropTypes.bool,
  rel: PropTypes.string
};
A.defaultProps = {
  className: null,
  children: null,
  onClick: function onClick() {
    return undefined;
  },
  href: null,
  route: null,
  routeParams: null,
  target: null,
  title: null,
  'aria-label': null,
  disabled: false,
  enabled: false,
  rel: 'nofollow noreferrer'
};
export default withMemo()(A);